import {templateConstants} from '../constants/template.constants'
const initialState = {
  templates: []
}

export function TemplateReducer (state = initialState, action) {
  switch (action.type) {
    case (templateConstants.GETALL_SUCCESS): {
      const successState = Object.assign({}, state, {templates: action.payload.templates})
      return successState
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/TemplateReducer.js